import MainHeading from './MainHeading'

export default MainHeading
